import React from 'react';
import { Typography, Alert, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';

const ExtractionReviewPage = () => {
  const navigate = useNavigate();

  return (
    <AdminLayout title="Extraction Review" requireSuperAdmin>
      <Alert severity="info" sx={{ mb: 3 }}>
        Extraction review is accessed through the tariff upload workflow.
      </Alert>

      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" paragraph>
          To review an extracted tariff:
        </Typography>
        <Typography variant="body2" component="ol" sx={{ pl: 2 }}>
          <li>Go to Tariff Management</li>
          <li>Upload a tariff PDF using the extraction tool</li>
          <li>Review and approve the extracted data</li>
        </Typography>
      </Box>

      <Button
        variant="contained"
        onClick={() => navigate('/admin/tariffs')}
      >
        Go to Tariff Management
      </Button>
    </AdminLayout>
  );
};

export default ExtractionReviewPage;
